export const TOOLTIP_ATTR = 'data-tooltip';
export const TOOLTIP_NOWRAP_ATTR = 'data-tooltip-nowrap';
export const TOOLTIP_TYPE_ATTR = 'data-tooltip-type';
export const TOOLTIP_HOVERED_ATTR = 'data-tooltip-hovered';

export const TOOLTIP_ADAPTIVE_ATTR = 'data-tooltip-adaptive';
